import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ExportOutlined, ReloadOutlined } from '@ant-design/icons';
import { Table, Button, Tag } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _ from 'lodash';
import qs from 'qs';
import { cleanObject, renderVatStatusTag, vatStatuses } from '@/utils/helpers';
import BaseSelect from '@/components/Elements/BaseSelect';
import { getProductWarehouseActive } from '@/redux/actions/ProductWarehouseAction';
import { inventoryStats, statsExportExcel } from '@/redux/actions/ProductActions';
import { checkPermission } from '@/utils/permission';
import { NotificationManager } from 'react-notifications';

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/product-statistics',
        breadcrumbName: 'Thống kê sản phẩm tồn kho',
    },
]

class InventoryStats extends Component {
    state = {
        isLoading: false,
        isLoadingExport: false
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);
        this.props.getProductWarehouseActive();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.loadData(query);
        }
    }

    loadData(query) {
        this.setState({ isLoading: true });
        this.props.inventoryStats(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        query = cleanObject(query);
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    do_export() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoadingExport: true });
        this.props.statsExportExcel(query).catch(err => {
            this.setState({ isLoadingExport: false });
        });
        this.setState({ isLoadingExport: false });
        NotificationManager.success("Quá trình xuất file đang được thực hiện. Vui lòng kiểm tra email của bạn sau ít phút.", "Thông báo", 9000);
    }

    render() {
        var { warehouse_list, items, pagination } = this.props;
        var { isLoading, isLoadingExport } = this.state;
        var query = qs.parse(this.props.location.search.slice(1));

        const columns = [
            {
                title: 'Tên sản phẩm',
                dataIndex: 'productName',
                key: 'productName',
                render: (text, record) => {
                    return (
                        <>{record.productName}</>
                    )
                }
            },
            {
                title: `SL chờ VAT`,
                dataIndex: 'qty_vat_pending',
                key: 'qty_vat_pending',
                sorter: true
            },
            {
                title: `SL có VAT`,
                dataIndex: 'qty_vat',
                key: 'qty_vat',
                sorter: true
            },

            {
                title: `SL chưa VAT`,
                dataIndex: 'qty_no_vat',
                key: 'qty_no_vat',
                sorter: true
            },
            {
                title: 'Tổng SL tồn',
                dataIndex: 'total_quantity',
                key: 'total_quantity',
                width: '100px'
            },
            // {
            //     title: 'Trạng thái VAT',
            //     dataIndex: 'vat_status',
            //     key: 'vat_status',
            //     width: '120px',
            //     render: (text, record) => {
            //         return (
            //             <>{renderVatStatusTag(record.vat_status)}</>
            //         )
            //     }
            // },
            {
                title: 'Kho',
                dataIndex: 'warehouseName',
                key: 'warehouseName',
                width: '300px',
                render: (text, record) => {
                    if (!record.warehouseName) return <Tag></Tag>;
                    return (
                        <>{record.warehouseName}</>
                    )
                }
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Sản phẩm" />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={false}
                        showFilter={false}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                    >
                        <BaseSelect
                            options={warehouse_list || []}
                            onChange={(value) => this.onChangeFilter("warehouse_id", value)}
                            optionValue="id"
                            showSearch
                            defaultValue={parseInt(query.warehouse_id) || null}
                            optionLabel="name"
                            placeholder="Kho hàng"
                            style={{ width: '300px' }}
                            className="table-button"
                        />
                        <BaseSelect
                            options={vatStatuses || []}
                            onChange={(value) => this.onChangeFilter("vat_status", value)}
                            optionValue="value"
                            showSearch
                            defaultValue={query.vat_status || null}
                            optionLabel="label"
                            placeholder="Trạng thái VAT"
                            style={{ width: '200px' }}
                            className="table-button"
                        />
                        {
                            checkPermission('product', 'stats_export') ? (
                                <Button className="table-button" loading={isLoadingExport} type='default' onClick={() => this.do_export()} icon={<ExportOutlined />}>Xuất file excel</Button>
                            ) : null
                        }
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                    </TableActionBar>
                </div>
                <Table
                    rowKey="id"
                    size="small"
                    tableLayout='auto'
                    dataSource={items || []}
                    columns={columns}
                    loading={isLoading}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`,
                        defaultPageSize: 30, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40', '50', '100', '200']
                    }}
                    onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {

    return {
        items: state.ProductReducer.inventoryStats.items,
        pagination: state.ProductReducer.inventoryStats.pagination,
        warehouse_list: state.ProductWarehouseReducer.product_warehouse_active_list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        inventoryStats: (filter) => dispatch(inventoryStats(filter)),
        getProductWarehouseActive: () => dispatch(getProductWarehouseActive()),
        statsExportExcel: (filter) => dispatch(statsExportExcel(filter))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryStats);
